import React from 'react';
import { motion } from 'framer-motion';
import { Formik, Form, Field, ErrorMessage } from 'formik';

import { useScrollFreeze } from '@hooks/useScrollFreeze';

import Exit from '@svg/exit.svg';
import ExitWhite from '@svg/exit-white.svg';

export const SubscribeModal = ({ setOpen, open }) => {
  useScrollFreeze();

  return (
    <motion.div
      key={open}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      className='bg-teal lg:bg-sand fixed top-0 left-0 min-h-screen w-full z-[100] flex flex-col items-center justify-center'>
      <div className='w-full absolute top-0 flex justify-end py-gutter lg:py-14 px-gutter lg:px-10'>
        <button
          onClick={() => setOpen(false)}
          className='rounded-full w-16 h-16 bg-white lg:bg-teal !bg-opacity-10 hover:!bg-opacity-100 nav-hover transition-standard'>
          <Exit className='p-5 w-full h-full hidden lg:block' />
          <ExitWhite className='p-5 w-full h-full lg:hidden' />
        </button>
      </div>
      <div className='grid grid-cols-14 w-full'>
        <span className='blockH3 text-white lg:text-teal text-left w-full block col-start-2 col-end-14 lg:col-start-3 lg:col-end-13'>
          Enter your email to join our newsletter
        </span>
        <Formik
          initialValues={{
            contactMethod: 'Email',
            email: '',
          }}
          validate={(values) => {
            const errors = {};
            if (values.contactMethod === 'Email') {
              if (!values.email) {
                errors.email = 'Email address is Required';
              } else if (
                !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
              ) {
                errors.email = 'Invalid email address';
              }
            }
            return errors;
          }}
          onSubmit={async (values, { setSubmitting, setStatus }) => {
            console.log('submitted');
            setSubmitting(true);
            await fetch('/.netlify/functions/subscribe', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(values),
            }).then((res) => {
              setSubmitting(false);
              setStatus('success');
            });
          }}>
          {({
            onChange,
            isSubmitting,
            status,
            values,
            /* and other goodies */
          }) => (
            <Form
              name='signup-form'
              data-netlify='true'
              data-netlify-honeypot='bot-field'
              subject='Signup Form'
              className='col-start-2 col-end-14 lg:col-start-3 lg:col-end-13'>
              {/* Hidden Fields for netlify */}
              <input type='hidden' name='form-name' value='contact-form' />
              <p hidden>
                <label>
                  <input name='bot-field' onChange={onChange} />
                </label>
              </p>
              {status === 'success' ? (
                <div className='mt-8 md:mt-12 blockH4 text-teal'>
                  Thank you for subscribing. You'll hear from us soon.
                </div>
              ) : (
                <div className='relative border-b border-white lg:border-teal flex items-center justify-between mt-8 md:mt-12'>
                  <div className='w-full'>
                    <Field
                      type='email'
                      name='email'
                      placeholder='Email'
                      className='text-white lg:text-teal blockH4 focus:outline-none bg-teal lg:bg-sand border-0 focus:shadow-none form-input focus:ring-0 p-0 pb-3 lg:pb-6 placeholder:text-white lg:placeholder:text-teal placeholder:blockH4 w-full'
                    />
                  </div>
                  <button type='submit'>
                    <div className='hidden lg:block'>
                      <svg
                        width='39'
                        height='17'
                        viewBox='0 0 39 17'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                        className='transition-standard'>
                        <path
                          d='M38.3216 8.9882C38.7447 8.56513 38.7447 7.8792 38.3216 7.45614L31.4273 0.561845C31.0042 0.138777 30.3183 0.138777 29.8952 0.561845C29.4722 0.984913 29.4722 1.67084 29.8952 2.09391L36.0235 8.22217L29.8952 14.3504C29.4722 14.7735 29.4722 15.4594 29.8952 15.8825C30.3183 16.3056 31.0042 16.3056 31.4273 15.8825L38.3216 8.9882ZM0 9.3055H37.5556V7.13883H0V9.3055Z'
                          fill={'#036483'}
                        />
                      </svg>
                    </div>
                    <div className='lg:hidden'>
                      <svg
                        width='29'
                        height='17'
                        viewBox='0 0 39 17'
                        fill='none'
                        xmlns='http://www.w3.org/2000/svg'
                        className='transition-standard'>
                        <path
                          d='M38.3216 8.9882C38.7447 8.56513 38.7447 7.8792 38.3216 7.45614L31.4273 0.561845C31.0042 0.138777 30.3183 0.138777 29.8952 0.561845C29.4722 0.984913 29.4722 1.67084 29.8952 2.09391L36.0235 8.22217L29.8952 14.3504C29.4722 14.7735 29.4722 15.4594 29.8952 15.8825C30.3183 16.3056 31.0042 16.3056 31.4273 15.8825L38.3216 8.9882ZM0 9.3055H37.5556V7.13883H0V9.3055Z'
                          fill={'#fff'}
                        />
                      </svg>
                    </div>
                  </button>
                </div>
              )}

              <ErrorMessage
                name='email'
                component='div'
                className='mt-4 blockH7 !text-green'
              />
            </Form>
          )}
        </Formik>
      </div>
    </motion.div>
  );
};
